const inlineStyles = {
    scaleText: {
        transform: 'translate(-5px, 5px)',
    },
};
export default inlineStyles;
